export const getPreferenceProps = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/preferences/getters.js